import { Component, OnInit, Input } from '@angular/core'

import { VismaService } from '../visma.service'

@Component({
  selector: 'app-callback',
  templateUrl: './callback.component.html',
  styleUrls: ['./callback.component.scss']
})
export class CallbackComponent implements OnInit {
  @Input() part: any
  @Input() site: any

  constructor(private visma: VismaService) { }

  ngOnInit() {
    const url = new URL(window.location.href)
    const code = url.searchParams.get('code')
    this.visma.getToken({ site: this.site, code }).subscribe((result: any) => {
      console.log('-- backend replies --')
      console.log(result)
    })
  }
}
